/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { AppTemplateProvidersProps } from './types/app-template-providers-props';
import { ConfigProvider } from '@revenuewell/logic-config';
import { AppStateProvider } from '@revenuewell/logic-app-state';
import { NavigationProvider } from '@revenuewell/logic-navigation';
import { NotificationProvider } from '@revenuewell/logic-notification';
import { ConfirmationProvider } from '@revenuewell/logic-confirmation';
import { StaticFilesProvider } from '@revenuewell/logic-static-files';
import { MobileFocusProvider } from '../../hooks/mobile-focus/mobile-focus';
import { DefaultTheme } from '@revenuewell/ui-theme';
import { DesktopProvider } from '@revenuewell/logic-desktop';
import { ThemeProvider, StyledEngineProvider } from '@mui/material';

export function CoreProviders(
  props: React.PropsWithChildren<AppTemplateProvidersProps>
) {
  const prodConfigPath = props.prodConfigPath ?? 'config/config.json'

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={DefaultTheme}>
        <StaticFilesProvider>
          <DesktopProvider isDesktopWidget={props.isDesktopWidget ?? false}>
              <NotificationProvider>
                <ConfirmationProvider>
                  <AppStateProvider>
                    <MobileFocusProvider>
                      <NavigationProvider>
                        <ConfigProvider
                          isProduction={props.isProduction}
                          devConfig={props.devConfig}
                          prodConfigPath={prodConfigPath}
                        >
                          {props.children}
                        </ConfigProvider>
                      </NavigationProvider>
                    </MobileFocusProvider>
                  </AppStateProvider>
                </ConfirmationProvider>
              </NotificationProvider>
          </DesktopProvider>
        </StaticFilesProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}